// AUTO-GENERATED. Do not edit. Run scripts/generate-version.mjs.
export const APP_VERSION = {
  version: '0.5.1',
  gitSha: 'b3cf64b',
  buildDate: '2026-06-29T20:30:13.842Z',
} as const;
